import TemplatesService from "@/modules/setup/templates/TemplatesService";

export default {
  namespaced: true,
  state: {
    modal: {
      show: false
    },
    templates: {
      loading: false,
      rows: []
    },
    selectedTemplate: null
  },
  actions: {
    showModal({commit}) {
      commit('showModal');
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async createTemplate({dispatch}, payload) {
      let response = await TemplatesService.createTemplate(payload)
      if (response.success) {
        dispatch('getTemplates')
      }
      return response
    },
    async getTemplates({commit}) {
      commit('changeTemplatesLoading');
      const res = await TemplatesService.getTemplates(null, 'template_type');
      const {success, body} = res;
      if (success) {
        commit('getTemplates', body);
      }
      commit('changeTemplatesLoading');
      return res;
    },
    selectTemplate({commit}, template) {
      commit('selectTemplate', template);
    },
    async updateTemplate({commit}, payload) {
      const res = await TemplatesService.updateTemplate(payload.uuid, payload, 'template_type');
      const {success, body} = res;
      if (success) {
        commit('updateTemplate', body);
      }
      return res;
    },
    async deleteTemplate({dispatch, commit}, payload) {
      let response = await TemplatesService.removeTemplate(payload.uuid);
      if (response.success) {
        commit('selectTemplate', null);
        dispatch('getTemplates')
      }
      return response
    }
  },
  mutations: {
    showModal: state => state.modal.show = true,
    hideModal: state => state.modal.show = false,
    getTemplates: (state, templates) => {
      state.templates.rows = templates;
      if (!state.selectedTemplate) {
        state.selectedTemplate = templates && templates.length ? templates[0] : null;
      }
    },
    changeTemplatesLoading: state => state.templates.loading = !state.templates.loading,
    selectTemplate: (state, template) => state.selectedTemplate = template,
    updateTemplate: (state, template) => {
      const index = state.templates.rows.findIndex(b => b.uuid === template.uuid);
      state.templates.rows[index] = template;
      state.templates.rows = [...state.templates.rows];

      if (state.selectedTemplate && template.uuid === state.selectedTemplate.uuid) {
        state.selectedTemplate = {...template};
      }
    },
  }
};
